import { Button, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import CustomTable from "../components/CustomTable";
import FilterBase from "../components/Filter";
import usePagination from "../hooks/Pagination";
import { Filter, Pagination } from "../interfaces/RequestBase";
import { TableTemplate } from "../interfaces/Table";
import { TestFilter, TestSearch, TestTable } from "../interfaces/Test";
import EditIcon from "@mui/icons-material/Edit";
import DataTextField from "../components/DataInputs/DataTextField";
import DataSwitch from "../components/DataInputs/DataSwitch";
import getFilter from "../utilities/filter";
import { GetTests } from "../requester/functions";
import { useNavigate } from "react-router-dom";

interface IProps {}

const TestsPage = (props: IProps) => {
	const navigate = useNavigate();

	const [totalCount, setTotalCount] = useState<number>(0);
	const [tests, setTests] = useState<TestTable[]>([]);
	const [pagination, setPage, setPageSize] = usePagination();
	const [filter, setFilter] = useState<TestFilter>({});
	const [search, setSearch] = useState<TestSearch>({});

	const rows: TableTemplate = {
		data: [
			{
				key: "name",
				title: "Название",
			},
			{
				key: "success_count",
				title: "Колличество для прохождения",
			},
			{
				key: "question_count",
				title: "число вопросов",
			},
			{
				title: "",
				render: (item: TestTable) => (
					<IconButton
						onClick={() => {
							navigate(`/test/${item.id}`);
						}}
					>
						<EditIcon />
					</IconButton>
				),
			},
		],
	};

	const getTestExport = (callback: any) => {
		var req: Filter<TestFilter, TestSearch> = getFilter(
			{ page: 0, size: totalCount } as Pagination,
			filter,
			search
		);

		GetTests(req, (resp) => {
			if (resp.status === "ok") {
				if (resp.data) {
					callback(resp.data.data);
				}
			}
		});
	};

	useEffect(() => {
		var req: Filter<TestFilter, TestSearch> = getFilter(
			pagination as Pagination,
			filter,
			search
		);

		GetTests(req, (resp) => {
			if (resp.status === "ok") {
				if (resp.data) {
					setTests(resp.data.data);
					setTotalCount(resp.data?.total_count || 0);
				}
			}
		});
	}, [filter, pagination, search]);

	return (
		<div className="flex flex-col items-end gap-5">
			<div className="flex justify-between w-full">
				<Button
					onClick={() => {
						navigate("/test/create");
					}}
				>
					Создать
				</Button>
				<FilterBase setSearch={setSearch} setFilter={setFilter}>
					<DataTextField
						value={search}
						setValue={setSearch}
						keyValue={"name"}
						inputProps={{
							label: "Имя",
						}}
					/>
					<DataSwitch
						value={filter}
						setValue={setFilter}
						keyValue={"is_delete"}
						label={"Архивные"}
					/>
				</FilterBase>
			</div>
			<CustomTable
				rows={rows}
				data={tests}
				allCount={totalCount}
				pagination={pagination as Pagination}
				setPage={setPage as (p: number) => void}
				setPageSize={setPageSize as (p: number) => void}
				onExport={getTestExport}
			/>
		</div>
	);
};

export default TestsPage;
